import React from "react";
import Keycloak from "keycloak-js";
import { useEffect, useState, useMemo } from "react";
import { SscIamContext } from "./SscIamContext";
import { removeQueryParameters } from "./utils";

export const SscIamProvider = ({ children, onLoad, oidcProvider, clientId, onAuthenticationComplete }) => {
  const [ssciamAuth, setSsciamAuth] = useState({ authenticated: false });
  const [status, setStatus] = useState("initializing");

  const keycloak = useMemo(() => {
    return new Keycloak({
      //@ts-expect-error the oidcProvider does exist, type def is wrong
      oidcProvider,
      clientId,
    });
  }, [oidcProvider, clientId]);

  useEffect(() => {
    if (status !== "initializing" || keycloak.didInitialize) return;

    keycloak
      .init({
        pkceMethod: "S256", // Enable PKCE
        responseMode: "query",
        checkLoginIframe: false,
        redirectUri: removeQueryParameters(window.location.href),
        ...(onLoad ? { onLoad } : {}),
      })
      .then((authenticated) => {
        const updatedAuth = {
          authenticated: authenticated,
          token: keycloak.token,
          tokenParsed: keycloak.tokenParsed,
          idToken: keycloak.idToken,
          idTokenParsed: keycloak.idTokenParsed,
          refreshToken: keycloak.refreshToken,
          refreshTokenParsed: keycloak.refreshTokenParsed,
        };

        setSsciamAuth(updatedAuth);
        setStatus("ready");

        // authentication is true if user has logged in
        if (authenticated) {
          onAuthenticationComplete(updatedAuth);
        }
      })
      .catch((error) => {
        console.log("Keycloak init() failed", error);
        setStatus("error");
      });
  }, [ssciamAuth, status, keycloak, onAuthenticationComplete, onLoad]);

  const props = {
    login: (options) => {
      setStatus("loading");
      return Promise.resolve(keycloak.login(options));
    },
    logout: (options) => {
      setStatus("loading");
      return Promise.resolve(keycloak.logout(options));
    },
    createLogoutUrl: (options) => {
      setStatus("loading");
      return Promise.resolve(keycloak.createLogoutUrl(options));
    },
    ...ssciamAuth,
    status,
  };

  return <SscIamContext.Provider value={props}>{children}</SscIamContext.Provider>;
};
